import { useEffect, useState } from 'react'

// Tracks the live width of the element referenced by `ref` via ResizeObserver.
// Returns `null` until the first measurement lands.
export function useContainerWidth(ref) {
  const [width, setWidth] = useState(null)

  useEffect(() => {
    const element = ref?.current

    if (element) {
      const observer = new ResizeObserver(entries => {
        const entry = entries[0]

        if (!entry) {
          return
        }

        // `contentBoxSize` excludes padding; fall back to clientWidth for
        // browsers that populate only `contentRect`.
        const nextWidth = Array.isArray(entry.contentBoxSize)
          ? entry.contentBoxSize[0]?.inlineSize
          : entry.contentBoxSize?.inlineSize

        setWidth(nextWidth ?? element.clientWidth)
      })

      observer.observe(element)

      return function cleanup() {
        observer.disconnect()
      }
    }
  }, [ref])

  return width
}
